<script lang="ts">
/**
 * Hand-rolled 24×24 stroke icons. A whole icon package would be the third
 * largest dependency in the bundle for the ~40 glyphs this app needs.
 */
export const ICONS = {
  home: 'M3 10.5 12 3l9 7.5M5.25 9.75V20a1 1 0 0 0 1 1h3.5v-5.5h4.5V21h3.5a1 1 0 0 0 1-1V9.75',
  file: 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5',
  'file-text': 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M9 13h6M9 17h4',
  receipt: 'M6 3h12v17l-3-1.6-3 1.6-3-1.6-3 1.6zM9 8h6M9 12h4',
  inbox: 'M5 5h14l2 7v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6zM3 12h5l1.5 3h5L16 12h5',
  users:
    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
  user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8',
  truck:
    'M3 6h11v10H3zM14 9h4l3 3v4h-7zM7.5 19a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M17.5 19a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5',
  box: 'M21 8.5 12 3.5 3 8.5v7L12 21l9-5.5zM3 8.5 12 13.5m0 0 9-5M12 13.5V21',
  bank: 'M3 21h18M4 10h16M6 10v11M10 10v11M14 10v11M18 10v11M12 3l9 5H3z',
  book: 'M4 4.5A2.5 2.5 0 0 1 6.5 2H20v18H6.5A2.5 2.5 0 0 0 4 22zM8 7h8M8 11h5',
  chart: 'M3 21h18M6 17v-5M11 17V7M16 17v-8',
  settings: 'M4 6h9M17 6h3M4 12h4M12 12h8M4 18h8M16 18h4M15 4v4M8 10v4M12 16v4',
  'chevron-down': 'm6 9 6 6 6-6',
  'chevron-up': 'm18 15-6-6-6 6',
  'chevron-left': 'm15 18-6-6 6-6',
  'chevron-right': 'm9 18 6-6-6-6',
  'chevrons-up-down': 'm7 15 5 5 5-5M7 9l5-5 5 5',
  'chevrons-left': 'm11 17-5-5 5-5M18 17l-5-5 5-5',
  'chevrons-right': 'm13 17 5-5-5-5M6 17l5-5-5-5',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16M21 21l-4.35-4.35',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  check: 'm20 6-11 11-5-5',
  x: 'M18 6 6 18M6 6l12 12',
  'alert-triangle':
    'M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0M12 9v4M12 17h.01',
  'alert-circle': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M12 8v5M12 16h.01',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M12 16v-5M12 8h.01',
  'help-circle':
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M9.4 9.3a2.6 2.6 0 1 1 3.4 2.5c-.8.3-1.3 1-1.3 1.8v.4M12 17h.01',
  'check-circle': 'M21.5 11.1V12a9 9 0 1 1-5.3-8.2M21 5l-9 9-2.5-2.5',
  sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  moon: 'M20 14.5A8.5 8.5 0 1 1 9.5 4a6.7 6.7 0 0 0 10.5 10.5',
  monitor: 'M3 4h18v12H3zM8 20h8M12 16v4',
  menu: 'M4 6h16M4 12h16M4 18h16',
  'panel-left': 'M3 4h18v16H3zM9 4v16',
  'log-out': 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
  building:
    'M4 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16M14 9h4a2 2 0 0 1 2 2v10M3 21h18M8 7h2M8 11h2M8 15h2M17 13h1M17 17h1',
  download: 'M12 3v12M7 11l5 5 5-5M4 21h16',
  upload: 'M12 21V9M7 13l5-5 5 5M4 3h16',
  trash: 'M4 7h16M10 11v6M14 11v6M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13M9 7V4h6v3',
  pencil: 'm4 20 4.5-1L19.5 8a2.1 2.1 0 0 0-3-3L5.5 16zM15 6.5l3 3',
  filter: 'M3 5h18l-7 8v6l-4 2v-8z',
  calendar: 'M4 5h16v16H4zM4 10h16M8 3v4M16 3v4',
  'more-horizontal': 'M6 12h.01M12 12h.01M18 12h.01',
  'external-link': 'M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5',
  'arrow-up': 'M12 20V5M6 11l6-6 6 6',
  'arrow-down': 'M12 4v15M6 13l6 6 6-6',
  'arrow-left': 'M20 12H5M11 6l-6 6 6 6',
  'arrow-right': 'M4 12h15M13 6l6 6-6 6',
  'arrow-up-right': 'M8 16 16.5 7.5M9 7h8v8',
  loader:
    'M12 3v3M12 18v3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M3 12h3M18 12h3M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1',
  eye: 'M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6',
  copy: 'M9 9h11v11H9zM5 15H4V4h11v1',
  refresh: 'M21 12a9 9 0 1 1-2.6-6.4M21 3v6h-6',
  command: 'M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3',
  'credit-card': 'M3 6h18v12H3zM3 10h18M6.5 14h3',
  link: 'M10 13a5 5 0 0 0 7.5.6l3-3a5 5 0 0 0-7-7l-1.7 1.7M14 11a5 5 0 0 0-7.5-.6l-3 3a5 5 0 0 0 7 7l1.7-1.7',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M12 7v5l3 2',
  euro: 'M18 6.5A7 7 0 0 0 8 9m0 6a7 7 0 0 0 10 2.5M4 10h9M4 14h9',
  printer: 'M6 9V3h12v6M6 18H4v-6h16v6h-2M8 14h8v7H8z',
  lock: 'M6 11h12v10H6zM9 11V7a3 3 0 0 1 6 0v4',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  percent: 'm19 5-14 14M7.5 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4M16.5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4',
  tag: 'M3 12V4h8l9 9-8 8zM7.5 8h.01',
  play: 'M7 4.5v15l13-7.5z',
  sparkle:
    'M12 3l2.1 5.4L19.5 10.5l-5.4 2.1L12 18l-2.1-5.4L4.5 10.5l5.4-2.1zM18.5 16.5l.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9z',
} as const

export type IconName = keyof typeof ICONS
</script>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    name: IconName
    size?: number | string
    strokeWidth?: number
    /** Screen-reader label. Omit for purely decorative icons. */
    label?: string
  }>(),
  { size: 16, strokeWidth: 1.75 },
)

const path = computed(() => ICONS[props.name])
// Dot-style glyphs need a fat round cap to read as dots at all.
const width = computed(() => (props.name === 'more-horizontal' ? 2.75 : props.strokeWidth))
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    :stroke-width="width"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    :aria-hidden="label ? undefined : true"
    :aria-label="label"
    :role="label ? 'img' : undefined"
    class="shrink-0"
  >
    <path :d="path" />
  </svg>
</template>
